// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getAuth, OAuthProvider, GoogleAuthProvider } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// TODO: Replace with your Firebase project configuration
// Get this from Firebase Console > Project Settings > Your apps > Web app

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics and get a reference to the service
export const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = initializeFirestore(app, {
  // Switch to experimentalForceLongPolling to resolve 'ID: ca9' assertion failures.
  // This is more stable than auto-detect in environments with restrictive stream handling.
  experimentalForceLongPolling: true
});

// Initialize Realtime Database (Explicitly specifying the asia-southeast1 URL)
export const database = getDatabase(app, "https://asgard-duels-default-rtdb.asia-southeast1.firebasedatabase.app");

// Initialize Cloud Functions
export const functions = getFunctions(app, "us-central1");

// Initialize Firebase Storage
export const storage = getStorage(app);

// Create Discord OAuth provider
export const discordProvider = new OAuthProvider('oidc.discord');
// Add scopes if needed
discordProvider.addScope('identify');
discordProvider.addScope('email');

// Set custom parameters to ensure we get the email
discordProvider.setCustomParameters({
  prompt: 'consent'
});

// Create Google Auth provider
export const googleProvider = new GoogleAuthProvider();

export default app;